import { defineMessages } from 'react-intl';

import commonMsg from 'messages';
import supplierMsg from 'messages/Models/Supplier';
import ServiceInfoMsg from 'messages/Models/ServiceInfo';
import ContractMsg from 'messages/Models/Contract';
import UserMsg from 'messages/Models/User';
import CityMsg from 'messages/Models/City';
import CardTitleMsg from './CardTitle';

const messages = {
  ...commonMsg,
  ...defineMessages({
    supplierEmployeesSaveAlert: '有{rowsCount}行账号信息保存失败',
  }),
  ...supplierMsg,
  ...ServiceInfoMsg,
  ...CardTitleMsg,
  ...ContractMsg,
  ...UserMsg,
  ...CityMsg,
};

export default messages;
